export interface ICounselor {
    id: number,
    firstName: string,
    lastName: string,
    assignedTodayCount: number,
    donorConnectCaseLoad: number,
    followUpCount: number,
    activeCaseCount: number
}